import { useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import { useNavigate } from "react-router-dom";
import { VerifyLoginCredential } from "../Services/AuthLogin/LoginApi";
import './Login.css'
import { ERROR_MESSAGES } from "../App/components/GlobalMassage";
const Login = () => {
 
//   const { login } = useAuth();
//   const navigate = useNavigate();
  const navigate=useNavigate()
//   const { setLoader } = useContext(AuthContext);

  useEffect(() => {
    document.title = "Admin Login | Techno Land";
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    const value = e.target.value.replace(/\s/g, '');
    setLoginObj({ ...loginObj, [e.target.name]: value });
  };

  const handleKeyDown = (e) => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };
  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage("");

   
    try {
      const response = await VerifyLoginCredential(loginObj); // Make API call

      if (response?.data?.statusCode === 200) {
        login(response.data.responseData.data.token, response.data.responseData.data);
      } else {
        setErrorMessage(response?.data?.errorMessage || "Invalid credentials.");
      }
    } catch (error) {
      setErrorMessage("An unexpected error occurred. Please try again.");
    } finally {
    //   setLoader(false);
    }
  };
  const [requireErrorMessage, setRequireErrorMessage] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState();
  const [showPassword, setShowPassword] = useState(false);
  
  const { login } = useAuth();

  const [loginObj, setLoginObj] = useState({
    userName: null,
    password: '',
    loginFrom: null,
    macAddress: null
  });



  const LoginBtnClicked = () => {
    // debugger;
    setErrorMessage('');
    if (loginObj.userName === undefined || loginObj.password === '') {
      setRequireErrorMessage(true);
      return false; // Return false or break the execution if password or email id is not fullFilled there regex condition.
    } else {
      setRequireErrorMessage(''); // Clear the error message if there are no errors.
    }

    setErrorMessage('');

    const ApiRequest_ParamsObj = {
      email: loginObj.userName,
      password: loginObj.password,
     
    };
    LoginData(ApiRequest_ParamsObj);
  };

  const LoginData = async (ApiRequest_ParamsObj) => {
    try {
      const response = await VerifyLoginCredential(ApiRequest_ParamsObj);
// debugger

      if (response?.data?.statusCode === 200) {

        const userToken = response?.data.responseData.data.token;
      const userData = response?.data.responseData.data.adminKeyID; // Extract user ID
      
       
        login(userToken, userData);


        // window.history.pushState(null, '', '/');
      } else {
        // Handle all types of errors
        const rawErrorMessage = response.response?.data?.errorMessage;
        const errorMessage =
          typeof rawErrorMessage === 'string'
            ? rawErrorMessage
            : rawErrorMessage?.sqlMessage || rawErrorMessage?.message || 'An error occurred.';
        // setLoader(false);
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      console.error('Login failed:', error);
    //   setLoader(false);
      setErrorMessage('An unexpected error occurred. Please try again.');
    } finally {
    //   setLoader(false);
    }
  };



  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  

  return (
<div className="login-container d-flex align-items-center justify-content-center bg-light">
  <div className="row w-75 shadow-lg rounded overflow-hidden">
    
    {/* Left Image Section */}
    <div className="col-md-6 d-none d-md-block">
      <div
        className="login-image h-100 w-100"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/about/redlogo.png)` }}
      ></div>
    </div>

    {/* Right Login Form */}
    <div className="col-md-6 bg-white d-flex align-items-center justify-content-center">
      <div className="login-card w-100">
        <h3 className="text-center mb-4 text-dark">Admin Login</h3>

        <div className="mb-3">
          <label className="form-label">Email ID</label>
          <input
            type="text"
            name="userName"
            value={loginObj.userName}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            className="form-control"
            placeholder="Enter Email ID"
            required
          />
          {requireErrorMessage && (!loginObj.userName || loginObj.userName.trim() === '') && (
            <span className="text-danger ">{ERROR_MESSAGES}</span>
          )}
        </div>

        <div className="mb-4">
          <label className="form-label">Password:</label>
          <div className="position-relative">
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              value={loginObj.password}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              className="form-control"
              placeholder="Enter password"
              required
              style={{ paddingRight: '40px' }}
            />
            <span
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              style={{
                position: 'absolute',
                right: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                color: '#6c757d'
              }}
            >
              <i className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
            </span>
          </div>
          {requireErrorMessage && (!loginObj.password || loginObj.password.trim() === '') && (
            <span className="text-danger ">{ERROR_MESSAGES}</span>
          )}
        </div>

        <button
          type="submit"
          
          onClick={LoginBtnClicked}
          className="btn w-100 fw-bold text-white"
          style={{padding:'11px', backgroundColor: '#ef2830' }}
        >
          Login
        </button>
  <span style={{color:'red'}}>  {ErrorMessage}</span>
      </div>
    </div>
  </div>
</div>


  );
};

export default Login;
